export const CUSTOM_ANALYTICS_QUERY_SORT_LIMIT = 45;
export const CUSTOM_ANALYTICS_QUERY_ROW_LIMIT_MAX = 2000;
